import { FETCH_COMPANIES_STARTED } from '../types'

export default function reduceLatestRequestKey(
  state = null,
  { type, meta: { requestKey } = {} }
) {
  if (type === FETCH_COMPANIES_STARTED) return requestKey
  return state
}
